import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import { InputBase, Box, Button, useTheme, InputAdornment, TextField, IconButton, Grid, Typography } from "@mui/material";


const Search = styled("div")(({ theme }) => ({
  flexGrow: 1,
  display: "flex",
  alignItems: "center", // Ensure icon aligns properly
  width: "100%",
  maxWidth: "330px",
  borderRadius: "15px",
  border: "1px solid #E6E6E6",
  boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
  padding: "1px 5px", // Adjust padding for spacing
  [theme.breakpoints.up("lg")]: {
    maxWidth: "89%",
  },
}));

const SearchIconWrapper = styled("div")({
  padding: "0 10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#B1B1B1",
});

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  // height: '50px',
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(2)})`,
    paddingRight: `calc(1em + ${theme.spacing(4)})`,
    fontSize: "14px", // ขนาดตัวอักษร
    fontFamily: "Sarabun, sans-serif", // ฟอนต์
  },
}));

interface ISearchSelectPerson {
  setSearchString: (value: string) => void;
  searchInput: string;
  setSearchInput: (value: string) => void;
}

const SearchSelectPerson: React.FC<ISearchSelectPerson> = ({setSearchString, searchInput, setSearchInput}) => {
  const [searchQuery, setSearchQuery] = useState("");
  // const [searchInput, setSearchInput] = useState("");
  const theme = useTheme();
  const [showError, setShowError] = useState(false);

  const handleSearch = () => {
    setSearchString(searchInput) 
    // alert("Search clicked with query: " + searchInput);
    // if (searchInput.trim() === "") {
    //   setShowError(true);
    // } else {
    //   setShowError(false);
    // }
  };

  const handleKeyDownSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    setSearchInput(value.trimStart());
    // if (value === "") {
    //   setSearchQuery("");
    // }
  };
  // useEffect(() => { }, [searchQuery]);
  return (
    <Grid>
      <Box
        display="flex"
        alignItems="center"
        mt={4}
        flexWrap="nowrap" // ✅ ป้องกันการขึ้นบรรทัดใหม่
        gap={2} // ✅ จัดระยะห่างให้สม่ำเสมอ
        sx={{ width: "100%" }} // ✅ รองรับการขยาย
      >

        {/* กล่องค้นหา */}
        <Search sx={{ flexGrow: 1, borderRadius: "10px", minWidth: 200 }}>
          <StyledInputBase
            placeholder="ค้นหาเลขที่เอกสาร"
            inputProps={{ "aria-label": "search" }}
            value={searchInput}
            onChange={handleSearchInputChange}
            onKeyDown={handleKeyDownSearch}
          />
          <InputAdornment position="end">
            <IconButton sx={{
              cursor: "text",
              pointerEvents: "auto",
              "&:hover": {
                backgroundColor: "transparent", // Example hover effect
              },
            }}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        </Search>


        {/* ปุ่มค้นหา */}
        <Button
          variant="contained"
          onClick={handleSearch}
          sx={{
            flexShrink: 0,
            minWidth: 106,
            // height: 52,
            whiteSpace: "nowrap",
            backgroundColor: "#2F6E89",
            color: "#fff",
            borderRadius: "10px",
            fontFamily: "Sarabun, sans-serif",
            "&:hover": {
              backgroundColor: "#2F6E89",
            },
          }}
        >
          ค้นหา
        </Button>
      </Box>
      <Box sx={{ ml: 4 }}>
      {showError && !searchInput && (
      <Typography color="error" fontSize={13}>กรุณากรอกข้อมูล</Typography>
   )}
      </Box>
    </Grid>
  );
}

export default SearchSelectPerson;